module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/leather@2x_38f4d5.jpg";